import React, { useState, useEffect } from "react";
import axios from "axios";
import Menu from "../Menu";
import { useNavigate } from "react-router-dom";
import Switch from "../../components/Switch";
import useApiUrls from "../../useApiUrls";
import Pagination from "../../components/Pagination";

const CatelogList = () => {
  const [data, setData] = useState([]);
  const [CatelogId, setCatelogId] = useState([]);
  const [message, setMessage] = useState("");
  const [publishInfo, setPublishInfo] = useState({}); // State to hold publish info
  const [dataLimit, setDataLimit] = useState(100);
  const [count, setCount] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  const { getUrlByOperation } = useApiUrls();
  const navigate = useNavigate();
  // const localStorageData = JSON.parse(localStorage.getItem("user"));
  // const token = localStorageData?.token;
  // const userid = localStorageData?.userid;
  const token = getCookie("token");
    const userid = getCookie("userid");


  // Fetch catalog and Catelog data
  useEffect(() => {
    const fetchCatalogAndCatelogData = async () => {
      try {
        const requestBody = {
          id: 0,
          applycreateddate: false,
          applymodifieddate: false,
          fromcreateddate: 0,
          endcreateddate: 0,
          frommodifieddate: 0,
          endmodifieddate: 0,
          active: "",
          catalogname: "",
          ispageload: false,
          pagesize: dataLimit,
          currentpageno: count,
          withoutpagination: false,
          pagedirection: "first",
        };
        
        const CatalogSearch = getUrlByOperation("CatalogSearch");
        const CatelogGetDistinct = getUrlByOperation("CatelogGetDistinct");

        // Fetch catalog data
        const catalogResponse = await axios.post(CatalogSearch, requestBody, {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
          },
        });
        if (catalogResponse.data && Array.isArray(catalogResponse.data.data)) {
          setData(catalogResponse.data.data);
        }

        // Fetch Catelog data
        const CatelogResponse = await axios.get(`${CatelogGetDistinct}/Catelogname`, {
          headers: {
            accept: "text/plain",
            "X-Authorization": token,
            UserId: userid,
          },
        });
        if (CatelogResponse.data && Array.isArray(CatelogResponse.data.data)) {
          setCatelogId(CatelogResponse.data.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCatalogAndCatelogData();
  }, [getUrlByOperation, token, userid, dataLimit, count]);

  // Pagination navigation functions
  const handleItemsPerPageChange = (newItemsPerPage) => {
    setDataLimit(newItemsPerPage);
    setCount(0); // Reset to first page when changing items per page
  };

  const goFirst = () => {
    if (count !== 0) setCount(0);
  };
  
  const goPrev = () => {
    if (count > 0) setCount(count - 1);
  };
  
  const goNext = () => {
    if (hasMore) setCount(count + 1);
  };

  const handlePageChange = (page) => {
    setCount(page - 1); // Convert 1-based page to 0-based index
  };

  const handleAddPop = () => {
    navigate("/addcatelog");
  };

  const handleUpdatePop = (id) => {
    navigate(`/updatecatelog/${id}`);
  };

  const handleShowImagePop = (id) => {
    navigate(`/showcatelog/${id}`);
  };

  const handlePreview = (id) => {
    const previewUrl = `/catelogpreview/${id}`;
    window.open(previewUrl, "_blank");
  };

  const encodeId = (id) => {
    const strId = id.toString();
    const base64Id = btoa(strId);
    return base64Id.substring(0, 10).padEnd(8, "0"); // Limit to 8-10 characters
  };

  const handlePublish = async (item) => {
    // Use publishid if available, otherwise fall back to encoded id
    const publishId = item.publishid && item.publishid.trim() !== '' 
      ? item.publishid 
      : encodeId(item.id);
      const type = "admin";
    
    const publishUrl = `${window.location.origin}/SMD/catelog/${type}/${publishId}`;
    setPublishInfo({ id: item.id, encodedUrl: publishUrl, encodedId: publishId });

    try {
      await navigator.clipboard.writeText(publishUrl);
      setMessage("URL copied to clipboard!");
    } catch (error) {
      console.error("Failed to copy URL:", error);
    }
  };

  const handleDelete = async (id) => {
    const requestBody = { id };

    try {
      const CatalogDelete = getUrlByOperation("CatalogDelete");
      await axios.post(CatalogDelete, requestBody, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json-patch+json",
        },
      });
      setMessage("Data deleted successfully!");
      setData(data.filter((item) => item.id !== id));
    } catch (error) {
      console.error("Error deleting item:", error);
      setMessage("Failed to delete data");
    }
  };

  const handleToggle = async (item) => {
    const CatalogActive = getUrlByOperation("CatalogActive");
    const CatalogDeactive = getUrlByOperation("CatalogDeactive");
    const apiUrl = item.active
      ? CatalogDeactive
      : CatalogActive;

    const requestBody = { id: item.id };

    try {
      await axios.post(apiUrl, requestBody, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json-patch+json",
        },
      });
      setData(
        data.map((d) => (d.id === item.id ? { ...d, active: !item.active } : d))
      );
    } catch (error) {
      console.error("Error updating status:", error);
      if (error.message === "relogin token expire") {
        navigate("/login");
      }
    }
  };

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="d-flex justify-content-between align-items-center w-100">
                <h1 className="mb-0">Catalogue</h1>
                <button type="button" className="btn btn-success" onClick={handleAddPop}>
                  Add Catalogue
                </button>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="container-fluid">
              <hr />
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body table-responsive p-0">
                      <table className="table table-hover table-striped">
  <thead className="thead-light">
    <tr>
      <th style={{width: '5%'}} className="text-center">Id</th>
      <th style={{width: '15%'}}>Name</th>
      <th style={{width: '15%'}}>Catalogue Description</th>
      <th style={{width: '12%'}} className="text-center">Show Images</th>
      <th style={{width: '25%'}} className="text-center">Action</th>
      <th style={{width: '10%'}} className="text-center">Active</th>
      {/* <th style={{width: '18%'}} className="text-center">Publish</th> */}
    </tr>
  </thead>
  <tbody>
    {data.map((item) => (
      <tr key={item.id}>
        <td className="text-center">{item.id}</td>
        <td>
          <strong>{item.catalogname}</strong>
        </td>
        <td>{item.remark || "-"}</td>
        <td className="text-center">
          <button 
            className="btn btn-sm btn-info"
            onClick={() => handleShowImagePop(item.id)}
          >
            <i className="fas fa-images mr-1"></i> 
            {/* Show Images */}
          </button>
        </td>
        <td className="text-center">
          <div className="btn-group">
            <button 
              className="btn btn-sm btn-warning mr-1" 
              onClick={() => handleUpdatePop(item.id)}
            >
              <i className="fas fa-edit mr-1"></i>
               {/* Update */}
            </button>
            <button 
              className="btn btn-sm btn-danger  mr-1" 
              onClick={() => handleDelete(item.id)}
            >
              <i className="fas fa-trash mr-1"></i>
               {/* Delete */}
            </button>
            {/* <button 
              className="btn btn-sm btn-primary mr-1" 
              onClick={() => handlePreview(item.id)}
            >
              <i className="fas fa-eye mr-1"></i>
               
            </button> */}
          </div>
        </td>
        <td className="text-center">
          <Switch 
            isOn={item.active} 
            handleToggle={() => handleToggle(item)} 
            id={item.id} 
          />
        </td>
        {/* <td className="text-center">
          {publishInfo.id === item.id ? (
            <div className="d-flex flex-column align-items-center">
              <span className="badge badge-info mb-2">{publishInfo.encodedId}</span>
              <button
                className="btn btn-sm btn-success"
                onClick={() => {
                  navigator.clipboard.writeText(publishInfo.encodedUrl);
                  setMessage("URL copied to clipboard!");
                }}
                title="Copy"
              >
                <i className="fas fa-copy mr-1"></i> Copy URL
              </button>
            </div>
          ) : (
            <button 
              className="btn btn-sm btn-success"
              onClick={() => handlePublish(item)}
            >
              <i className="fas fa-globe mr-1"></i> Publish
            </button>
          )}
        </td> */}
      </tr>
    ))}
  </tbody>
</table>
                    </div>
                    
                    {/* Pagination */}
                    <Pagination
                      currentPage={count + 1}
                      totalPages={hasMore ? count + 2 : count + 1}
                      onPageChange={handlePageChange}
                      itemsPerPage={dataLimit}
                      onItemsPerPageChange={handleItemsPerPageChange}
                      totalItems={data.length + (hasMore ? dataLimit : 0)}
                      showPageNumbers={false}
                      showItemsPerPageSelector={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message && (
        <div style={{ position: "fixed", top: "20px", right: "10px", width: "25%", zIndex: "9999" }}>
          <div
            className={`alert ${message === "Data deleted successfully!" ? "alert-success" : "alert-danger"} d-flex align-items-center`}
            role="alert"
            style={{ marginBottom: "10px" }}
          >
            <div>{message}</div>
          </div>
        </div>
      )}
    </>
  );
};

export default CatelogList;
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
